import React, {useEffect} from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles.css';  // Import the CSS file
import { AuthProvider } from './context/AuthContext';
import LoginPage from './components/authentication/LoginPage';
import RegisterPage from './components/authentication/RegisterPage';
import PlayStory from './components/stories/PlayStory';
import Profile from './components/profile/Profile';
import ProtectedRoute from './hooks/ProtectedRoute';
import ConfirmEmail from './components/authentication/ConfirmEmail';
import ForgotPassword from './components/authentication/ForgotPassword';
import ResetPassword from './components/authentication/ResetPassword';
import AdminConfig from './components/admin/AdminConfig';
import BrowseStories from './components/stories/BrowseStories';
import Layout from './components/common/Layout';
import ResendConfirmation from './components/authentication/ResendConfirmation';
import PrivacyPolicy from './components/common/PrivacyPolicy';
import TermsOfUse from './components/common/TermsOfUse';
import ContactUs from './components/common/ContactUs';
import { initGA } from './analytics/ga';
import PageTracker from './components/common/PageTracker';

function App() {

  useEffect(() => {
    initGA();
  }, []);

  return (
    <AuthProvider>
      <Router>
        <PageTracker />
        <div className="container">
          <Routes>
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/confirm-email" element={<ConfirmEmail />} />
            <Route path="/resend-confirmation" element={<ResendConfirmation />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />  
            <Route path="/story/:slug" element={<PlayStory />} />
            <Route element={<Layout />}>
              <Route path="/" element={<BrowseStories />} />
              <Route path='/browse-stories' element={<BrowseStories />} />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                } />
            </Route>
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminConfig />
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
